import { createSelector } from 'reselect';

import { State } from '../types';

export const uiSelector = (state: State): State['ui'] => state.ui;

export const selectUiIsOptionsVisible = createSelector(
  uiSelector,
  (ui) => ui.uploader.options.visible
);
